import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { BuilderPage } from '@/features/template-builder/builder-page';
import { parseBuilderSearch, type BuilderSearch } from '@/features/template-builder/search';

/**
 * The email template builder. Its own lazy chunk (with the editor and tiptap): the router splits
 * every route. The list route checks `template-tyres:read`.
 */
export const Route = createFileRoute('/_app/email-templates/builder')({
  staticData: { featureKey: 'template-builder-email' },
  validateSearch: (search: Record<string, unknown>): BuilderSearch =>
    parseBuilderSearch(search, 'email'),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'template-builder-email',
      permissions: ['template-tyres:read'],
    }),
  component: Builder,
});

function Builder() {
  const { group, type } = Route.useSearch();
  // Keyed, so a link to another group or type starts from it rather than the open one.
  return (
    <BuilderPage
      key={`${group ?? ''}:${type ?? ''}`}
      kind="email"
      initialGroup={group}
      initialType={type}
    />
  );
}
